module.exports = __webpack_public_path__ + "img/sample_badge.3bd9917f.jpg";